import {
  Container,
  Title,
  Button,
  Image,
  LeftContainer,
  RightContainer,
  SubTitle,
  ButtonBox,
} from "./styles";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <Container>
      <LeftContainer>
        <Title>OnChef</Title>
        <SubTitle>Sistema para restaurante e lanchonete</SubTitle>

        <Link to="/new">
          <Button>
            <ButtonBox>{">"}</ButtonBox>
            Entre em contato
          </Button>
        </Link>
      </LeftContainer>

      <RightContainer>
        <Image />
      </RightContainer>
    </Container>
  );
}
